module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "loader": "spinner",
      "color": "#36304a",
      "width": 70
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Client User List")]), _vm._v(" "), _c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Search")]), _vm._v(" "), _c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Client User Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.common),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "common", $$v)
      },
      expression: "Filter.common"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Created By")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdBy",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Assigned User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.createdBy),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdBy", $$v)
      },
      expression: "Filter.createdBy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Status Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "id": "StatusType",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Status Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.StatusType),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "StatusType", $$v)
      },
      expression: "Filter.StatusType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('ClientUser_Master_List', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AddClientUser()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ClientUserList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "cu_id"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "cu_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "multi_client_name",
      fn: function(row1) {
        return [(row1.item.multi_client_name) ? _c('span', [_vm._v(_vm._s(row1.item.multi_client_name))]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.RaisedFrom) ? _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.RaisedFrom))]) : _vm._e(), _c('br')]
      }
    }, {
      key: "cu_name",
      fn: function(row2) {
        return [_vm._v(_vm._s(row2.item.cu_name))]
      }
    }, {
      key: "email",
      fn: function(row3) {
        return [_vm._v(_vm._s(row3.item.email))]
      }
    }, {
      key: "contact",
      fn: function(row4) {
        return [_vm._v(_vm._s(row4.item.contact))]
      }
    }, {
      key: "address",
      fn: function(row5) {
        return [(row5.item.address) ? _c('span', [_vm._v("\n                    Address : " + _vm._s(row5.item.address) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "is_active",
      fn: function(row6) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row6.item.cu_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row6.item.cu_id,
            "name": "approval",
            "value": row6.item.is_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row6.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row6.item.is_active == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row6.item.is_active == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _vm._e()]
      }
    }, {
      key: "is_approve",
      fn: function(row7) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row7.item.cu_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row7.item.cu_id,
            "name": "approval",
            "value": row7.item.is_approve == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.approveUser(row7.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row7.item.is_approve == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row7.item.is_approve == 1 ? "Approve" : "Pending"))])], 1)])], 1) : _vm._e()]
      }
    }, {
      key: "created_at",
      fn: function(row8) {
        return [(row8.item.created_at) ? _c('span', [_vm._v("\n                    Created : " + _vm._s(row8.item.created_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row8.item.createdBy) ? _c('span', [_vm._v("\n                    Created By : " + _vm._s(row8.item.createdBy) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row8.item.updated_at) ? _c('span', [_vm._v("\n                    Updated : " + _vm._s(row8.item.updated_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row8.item.updatedBy) ? _c('span', [_vm._v("\n                    Updated By : " + _vm._s(row8.item.updatedBy) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "action",
      fn: function(row9) {
        return [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editClientUser(row9.item)
            }
          }
        }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.SendClientUser(row9.item)
            }
          }
        }, [_vm._v("Approve")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a8c601","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientUserMaster/clientUserList.vue
// module id = 2562
// module chunks = 0